// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__Y3SEe","subheader":"ReorderModal_subheader__xBlV-","listWrap":"ReorderModal_listWrap__a9vVh"};